import _ from 'lodash';
import { Vue, BitrixVue } from 'ui.vue';
// import {Loc, Runtime, Type} from "main.core";
import './style.css';
Vue.component('vue-cart-contragent-select', {
    data() {
        return {
            changingAddress: false,
            changingContragent: false,
            contragent_error: '',
            contragent_info: '',
            address_error: '',
            address_info: '',
            error: null,
        };
    },
    computed: {
        localize: (state) => {
            return Vue.getFilteredPhrases('');
        },
        componentError: {
            get() {
                return this.error;
            },
            set(errorText) {
                if (this.error !== errorText) {
                    this.$root.$emit('componentError', { id: this.$options.name, text: errorText });
                    this.error = errorText;
                    if (this.error) {
                        if (BX.UI?.Notification?.Center) {
                            BX.UI.Notification.Center.notify({
                                content: this.error,
                                position: "bottom-right",
                                autoHide: true,
                                autoHideDelay: 2000,
                                closeButton: true,
                                category: "contragents-list-alert",
                            });
                        } else {
                            console.error(this.error);
                        }
                    }
                }
            }
        },
        basket_id: (state) => {
            return state.$store.getters['basket/getId'];
        },
        contragents: (state) => {
            state.checkAddressField();
            return state.$store.getters['getContragents'];
        },
        contragent: (state) => {
            return state.$store.getters['basket/getContragent'];
        },
        address: (state) => {
            return state.$store.getters['basket/getAddress'];
        },
        basket: (state) => {
            return state.$store.getters['basket/basket'];
        },
        basket_price: (state) => {
            return state.$store.getters['basket/basketPrice'];
        },
        contragent_id: {
            get() {
                return this.$store.getters['basket/getContragentId'];
            },
            set(val) {
                this.$store.commit("basket/changeContragent", val);
            }
        },
        address_id: {
            get() {
                return this.$store.getters['basket/getAddressId'];
            },
            set(val) {
                this.$store.commit("basket/changeAddress", val);
            }
        },
        contragentsLen: (state) => {
            if (state.contragents != undefined) {
                let keys = Object.keys(state.contragents);
                return keys.length;
            }
            return 0;
        },
        addressLen: (state) => {
            if (state.contragent?.ADDRESS != undefined) {
                return Object.keys(state.contragent.ADDRESS)?.length;
            }
            return 0;
        },
        contragentID: state => state.contragent?.ID,
        contragentKOD: state => state.contragent?.UF_KOD,
        contragentNAME: state => state.contragent?.NAME,
        contragentXML_ID: state => state.contragent?.XML_ID,
        addressID: state => state.address?.ID,
        addressNAME: state => state.address?.NAME,
        addressXML_ID: state => state.address?.XML_ID,
    },
    created() {
        // BX.addCustomEvent("OnAfterContragentChange", BX.delegate((event) => {
        //     this.bonusType = this.bonusPrograms[0]?.CODE;
        // }, this));
    },
    methods: {
        onChangeAddress: function () {
            this.checkAddressField();
        },
        checkAddressField: function () {
            if (this.address_id != undefined && this.contragent?.ADDRESS[this.address_id] != undefined) {
                this.address_error = '';
                this.address_info = '';
            } else if (this.contragent?.ADDRESS != undefined) {
                let key = Object.keys(this.contragent.ADDRESS);
                if (key.length > 1 || this.contragent?.ADDRESS[this.address_id] == undefined)
                    this.address_info = this.localize?.VUE_ADDRESS_NOT_SET || "VUE_ADDRESS_NOT_SET";
                else if (key.length == 0)
                    this.address_error = this.localize?.VUE_ADDRESS_NOT_AVAILABLE || "VUE_ADDRESS_NOT_AVAILABLE";
            } else {
                this.address_error = this.localize?.VUE_ADDRESS_NOT_AVAILABLE || "VUE_ADDRESS_NOT_AVAILABLE";
            }
            this.componentError = (this.address_error || this.address_info);
        },
        onChangeParams: function () {
            this.checkedBonus = false;
            this.spentBonusValue = 0;
            this.spentBonusPrice = 0;
        },
        changeContragent: function () {
            if (this.contragentsLen > 1)
                this.changingContragent = !this.changingContragent;
        },
        changeAddress: function () {
            if (this.addressLen > 1)
                this.changingAddress = !this.changingAddress;
        },
    },
    template: `
        <div v-if="contragents" class="row cart-contragent-selector">
            <div v-if="contragents" class="col-12 data-warp" :class="(contragent_error?'alert-danger':'')+(contragent_info?'alert-info':'')" :title="contragent_error||contragent_info">
                <label for="CONTRAGENT" class="title font-weight-bold mt-2 mb-0">
                    <i v-if="contragentsLen>1" class="fas fa-users"></i>
                    <i v-else class="fas fa-user"></i>
                    &nbsp;{{localize.CONTRAGENTS}}
                </label>
                <div class="data input-group mb-2 mr-sm-2">
                    <div v-cloak class="input-group-prepend">
                        <span
                            v-if="changingContragent != true && contragent != undefined"
                            :title="contragentsLen>1?'изменить контрагента':''"
                            class="px-3 pt-2"
                            @click="changeContragent"
                            @blur="changeAddress">
                            <a v-if="contragentsLen > 1" href="javascript:void(0)" class="cursor-pointer"><u>{{contragent.NAME}}</u></a>
                            <span v-else>{{contragent.NAME}}</span>
                        </span>
                        <select required v-else-if="contragents && contragentsLen > 1" v-model="contragent_id" class="form-control d-none" :class="contragentsLen?'d-inline':''" name="CONTRAGENT" id="CONTRAGENT" @blur="changeContragent">
                            <option :value="0" disabled hidden>Укажите контрагента</option>
                            <option v-for="agent in contragents" :value="agent.ID">{{agent.NAME}}</option>
                        </select>
                        <input required v-else type='text' name="CONTRAGENTS" id="CONTRAGENTS" placeholder="Укажите контрагента" class="form-control d-none" :class="!contragentsLen?'d-inline':''" />
                        <!-- <input v-else-if="contragent" class="form-control bg-none border-none w-100" disabled :value="contragent.NAME" /> -->
                        <input type="hidden" required name="CONTRAGENT_ID" :value="contragentID"/>
                        <input type="hidden" required name="CONTRAGENT_KOD" :value="contragentKOD"/>
                        <input type="hidden" required name="CONTRAGENT_NAME" :value="contragentNAME"/>
                        <input type="hidden" required name="CONTRAGENT_XML_ID" :value="contragentXML_ID"/>
                    </div>
                </div>
            </div>
            <div class="col-12 data-warp" :class="(address_error?'alert-danger':'')+(address_info?'alert-info':'')" :title="address_error||address_info">
                <label for="ADDRESS" class="title font-weight-bold mt-2 mb-0">
                    <i v-if="addressLen>1" class="fas fa-map-marker-alt"></i>
                    <i v-else class="fas fa-map-marker-alt"></i>
                    &nbsp;{{localize.ADDRESS}}</label>
                <div class="data input-group mb-2 mr-sm-2">
                    <div v-cloak class="input-group-prepend">
                        <span
                            v-if="changingAddress != true && contragent != undefined && contragent.ADDRESS != undefined && address != undefined"
                            :title="addressLen>1?'изменить адрес':'' + localize.CHANGE_ADDRESS"
                            class="px-3 pt-2"
                            @click="changeAddress"
                            @blur="changeAddress">
                            <a v-if="addressLen > 1" href="javascript:void(0)" class="cursor-pointer"><u>{{address.NAME}}</u></a>
                            <span v-else class="d-none" :class="addressLen>1?'':'d-inline'">{{address.NAME}}</span>
                        </span>
                        <select required v-else-if="contragent != undefined && contragent.ADDRESS != undefined" v-model="address_id" class="form-control d-none" :class="contragentsLen?'d-inline':''" name="ADDRESS" id="ADDRESS" @change="onChangeAddress" @blur="changeAddress">
                            <option v-if="!address_id" :value="0" disabled hidden>Укажите адрес доставки</option>
                            <option v-for="addres in contragent.ADDRESS" :value="addres.ID">{{addres.NAME}}</option>
                        </select>
                        <input required v-else type='text' name="ADDRESS" id="ADDRESS" placeholder="Укажите адрес доставки" class="form-control d-none" :class="!contragentsLen?'d-inline':''" />
                        <input type="hidden" required name="ADDRESS_ID" :value="addressID"/>
                        <input type="hidden" required name="ADDRESS_NAME" :value="addressNAME"/>
                        <input type="hidden" required name="ADDRESS_XML_ID" :value="addressXML_ID"/>
                    </div>
                </div>
            </div>
        </div>`
});
